module.exports = __webpack_public_path__ + "img/menuBg_bak.0ee385a5.png";